<template>
    <page>
		<module enable-flex>
			<m-operate>
				<c-button color="sys" icon="add" @click="addHandle(0)">新增一级分类</c-button>
				<c-button color="black" icon="release" @click="releaseHandle()">发布</c-button>
			</m-operate>
			
			<c-table ref="table" :paging="false">
				<c-table-column
					type="expand"
					label="分类名称"
					name="group_name"
					add-button="添加子分类"
					:expand-limit="systemConfig.sys_product_type_level_count"
					width="300"
					@expand="loadChildren"
					@add="addHandle"
				>
				</c-table-column>
				
				<c-table-column
					v-if="systemConfig.sys_product_type_link_type == 1 || systemConfig.sys_product_type_level_count > 1"
					label="图片"
				>
					<template v-slot="{data, expandData}">
						<div v-if="levelImageSize[expandData.level] && data.img_url" class="group-img flex-center">
							<img :src="data.img_url" alt="">
						</div>
					</template>
				</c-table-column>
				
				<c-table-column
					type="sort"
					label="排序"
					@sort="sortHandle"
				></c-table-column>
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="110"
				>
					<template v-slot="row">
						<c-table-button @click="editHandle(row)">编辑</c-table-button>
						<c-table-button @click="deleteHandle(row)">删除</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
		
		<c-dialog ref="dialog" :title="editState ? '编辑分类' : '添加分类'" width="600" height="350" @resolve="addChild">
			<c-form ref="form">
				<c-form-item type="input" label="分类名称" name="group_name" required></c-form-item>
				<c-form-item v-if="levelImageSize[editLevel]" type="image" label="分类图片" oss name="img_url" :file-word="`建议尺寸: ${levelImageSize[editLevel]}X${levelImageSize[editLevel]}px<br>jpg，png格式`" required></c-form-item>
				<template v-if="editLevel == systemConfig.sys_product_type_level_count - 1">
					<template v-if="systemConfig.sys_product_type_link_type == 1">
						<c-form-item v-if="editLevel > 0" type="link" label="跳转链接" name="redirect_params" required></c-form-item>
					</template>
					<c-form v-else ref="productForm" title="关联商品">
						<c-form-item v-model="currentProductSelectType" type="radio" label="关联方式" name="select_type" :options="productSelectType" required></c-form-item>
						<div v-show="currentProductSelectType == 1">
							<c-form-item type="select" label="所属品牌" name="brand" options="BRAND"></c-form-item>
							<c-form-item type="select" label="所属类目" name="classify_ids" options="PRODUCT_CLASSIFY" multiple></c-form-item>
							<c-form-item type="select" label="排序规则" name="sort_type" :options="sortOptions"></c-form-item>
						</div>
						<c-form-item v-show="currentProductSelectType == 2" label="手动选择">
							<div class="flex-center-cross">
								<c-button size="m" hollow @click="selectProduct">选择商品</c-button>
								<span style="margin-left: 10px; font-size: 13px; color: #666;">已选{{productIds.length}}件</span>
							</div>
						</c-form-item>
					</c-form>
				</template>
			</c-form>
		</c-dialog>
		
		<product-pick ref="productPick"></product-pick>
	</page>
</template>

<script>
	import productPick from '@/components/service/product_pick.vue'
	import {mapState} from 'vuex'
	
	export default {
		name: 'm_product_group',
		
		components: {
			productPick
		},
		
		data() {
			return {
				editState: false,
				editLevel: 0,
				
				productSelectType: [{
					name: '按条件关联',
					value: 1
				}, {
					name: '手动关联',
					value: 2
				}],
				currentProductSelectType: 1,
				sortOptions: [{
					name: '按综合排序',
					value: 'overall desc'
				}, {
					name: '按首次上架时间降序',
					value: 'first_sell_date desc'
				}, {
					name: '按销量降序',
					value: 'product_count desc'
				}],
				productIds: []
			}
		},
		
		computed: {
			...mapState(['systemConfig']),
			
			levelImageSize() {
				let fun = level => {
					return this.systemConfig.sys_product_type_link_type == 1
						? level == this.systemConfig.sys_product_type_level_count - 1
							? 148
							: level == 0 && this.systemConfig.sys_product_type_level_count == 3
								? 88
								: 0
						: level == 0 && this.systemConfig.sys_product_type_level_count > 1
							? 88
							: 0;
				}
				return {
					0: fun(0),
					1: fun(1),
					2: fun(2)
				}
			}
		},
		
		mounted() {
			this.$refs.table.load({
				url: '/product_group/list',
				data: {
					parent_id: 0
				}
			});
		},
		
		methods: {
			loadChildren(row, resolve) {
				this.request({
					url: '/product_group/list',
					data: {
						parent_id: row.data.id
					},
					success: data => {
						resolve(data);
					}
				});
			},
			
			addHandle(row, resolve) {
				this.editState = false;
				this.editLevel = row ? row.expandData.level + 1 : 0;
				this._edit = 0;
				this._parent = row ? row.data.id : 0;
				this._resolve = data => {
					row ? resolve(data) : this.$refs.table.push(data);
				};
				this.$refs.form.clear();
				this.$refs.dialog.open();
			},
			
			editHandle(row) {
				this.editState = true;
				this.editLevel = row.expandData.level;
				this._edit = row.data.id;
				this._parent = row.expandData.parent ? row.expandData.parent.data.id : 0;
				this._resolve = data => {
					row.update(data);
				};
				console.log(row.data);
				this.$refs.form.clear();
				if (this.systemConfig.sys_product_type_link_type == 2) {
					var data = Object.assign({}, row.data, JSON.parse(row.data.product_params || '{}'));
					this.productIds = data.product_ids || [];
				} else {
					var data = row.data;
				}
				this.$refs.form.set(data);
				this.$refs.dialog.open();
			},
			
			deleteHandle(row) {
                this.$confirm({
                    text: '确定要删除当前分类【'+row.data.group_name+'】吗？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/product_group/delete',
                            data: {
                                group_id: row.data.id
                            },
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '删除成功'
                                });
                                row.remove();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
			},
			
			sortHandle(row, type, next) {
				this.request({
					url: '/product_group/sort',
					data: {
						group_id: row.data.id,
						parent_id: row.expandData.parent ? row.expandData.parent.data.id : 0,
						sort_type: type
					},
					loading: true,
					success: data => {
						next();
					}
				});
			},
			
			addChild(stop) {
				stop();
				var data = this.$refs.form.serialize();
				if (!data.group_name) {
					this.$message({
						text: '请填写分类名称'
					});
					return;
				}
				
				if (this.levelImageSize[this.editLevel] && !data.img_url) {
					this.$message({
						text: '请选择分类图片'
					});
					return;
				}
				
				if (this.editLevel == this.systemConfig.sys_product_type_level_count - 1) {
					if (this.systemConfig.sys_product_type_link_type == 1) {
						if (!data.redirect_params) {
							this.$message({
								text: '请填写链接参数'
							});
							return;
						}
					} else {
						data.product_params = JSON.stringify(Object.assign(this.$refs.productForm.serialize(), {
							product_ids: this.productIds
						}));
					}
				}
				
				this.request({
					url: '/product_group/edit',
					data: Object.assign(data, {
						group_id: this._edit,
						parent_id: this._parent
					}),
					loading: true,
					success: data => {
						this.$message({
							text: this._edit ? '编辑成功' : '添加成功'
						});
						this.$refs.dialog.close();
						this._resolve(data);
					}
				});
			},
			//发布
			releaseHandle(row, resolve) {
				this.$confirm({
				    text: '确定要发布吗？',  // 提示内容,
				    buttonName: '确定',  // 确定按钮文字
				    cancelButton: true,  // 是否显示取消按钮
				    resolve: () => {
				        this.request({
				            url: '/product_group/release',
				            data: {},
				            loading: true,
				            success: data => {
				                this.$message({
				                    text: '发布成功',
									icon: 'success'  // 图标（success：成功，fail：失败）
				                });
				            }
				        });
				    },  // 确定按钮回调
				    cancel: () => {},  // 取消按钮回调
				});
			},
			
			selectProduct() {
				this.$refs.productPick.open({
					value: this.productIds,
					resolve: data => {
						this.productIds = data;
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.group {
		&-img {
			width: 40px;
			height: 40px;
		}
	}
</style>